const templates = [
    'async-load', 
    'custom-element',
    'detect-breakpoints',
    'detect-touch',
    'element-observer',
    'external-links',
    'fetch',
    'get-server-worker',
    'in-animation',
    'keyboard-focus',
    'load',
    'max-characters',
    'observer',
    'polyfill',
    'remove-breaks',
    'scroll-to-element',
    'scroll-to-link',
    'sticky',
    'subject',
    'tab-index-children',
    'toggle-class',
    'async-element',
];

export default templates;